<template>
  <p>People stuff for 2024</p>
</template>
